import { render, staticRenderFns } from "./QDataGrid.vue?vue&type=template&id=3b3ec137&scoped=true&"
import script from "./QDataGrid.vue?vue&type=script&lang=js&"
export * from "./QDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ec137",
  null
  
)

export default component.exports